import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as libraryActions from '~/library/actions';
type LibraryViewSummaryProps = {
  actions: object;
  libraryState: object;
};
class LibraryViewSummary extends React.Component<LibraryViewSummaryProps, {}> {
  updateActiveTab = tab => {
    this.props.actions.updateTab(tab);
  };
  render() {
    const { libraryState } = this.props;
    const { component = {} } = libraryState;
    const { libraryModel = {} } = component;
    const {
      description = '',
      bugTrackerUrl = '',
      codeRepoUrl = '',
      languageType = '',
      author = '',
      authorUrl = '',
    } = libraryModel;
    return (
      <div className="grid">
        {description && (
          <div className="grid__item col-1-1 pb">
            <div>{description}</div>
          </div>
        )}
        <div className="grid__item col-1-1">
          <div className="grid">
            <div className="grid__item col-1-3 phone--col-1-1">Issue Tracker:</div>
            <div className="grid__item col-2-3 phone--col-1-1 phone--no-overflow">
              <a href={bugTrackerUrl} target="_blank" className="link--primary">
                {bugTrackerUrl}
              </a>
            </div>
          </div>
        </div>
        <div className="grid__item col-1-1">
          <div className="grid pt-">
            <div className="grid__item col-1-3 phone--col-1-1">Source Code:</div>
            <div className="grid__item col-2-3 phone--col-1-1 phone--no-overflow">
              <a href={codeRepoUrl} target="_blank" className="link--primary">
                {codeRepoUrl}
              </a>
            </div>
          </div>
        </div>
        <div className="grid__item col-1-1">
          <div className="grid pt- pb+">
            <div className="grid__item col-1-3 phone--col-1-1">Author:</div>
            <div className="grid__item col-2-3 phone--col-1-1 phone--no-overflow">
              {authorUrl && languageType !== 'OBJECTIVEC' ? (
                <a href={authorUrl} className="link--primary">
                  {author}
                </a>
              ) : (
                <div>{author}</div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
function mapStateToProps(state) {
  return { libraryState: state.libraryState };
}
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(libraryActions, dispatch),
  };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LibraryViewSummary);
